// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__TtDaP","top":"styles_top__2rmK5"};